import * as gzErrorService from './error.service';

export default angular.module('gazelle.components.error', [
    'pascalprecht.translate',
    'ngMaterial'
])
  .service(gzErrorService.name, gzErrorService.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/error/error.module.js